export const NEWBUILDING_BROCHURE_KEY = 'newbuildingBrochure.Enabled';
